<template>
	<main class="notFound">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
					<h1>ページが見つかりませんでした</h1>
				</div>
				<p>
ご指定のページはありません。<br>
入力したURLが間違っている可能性がありますので、ご確認の上、再度アクセスをお願いいたします。
				</p>
			</div>
		</div>

		<section class="tips">
			<div class="container">
				<div class="rowView">
					<h2>よくある間違い</h2>
					<div class="noteContent">
						<p class="">
URLの最後が、[ / ]で終わっている場合
/about<span>/</span>
						</p>
					</div>
					<div class="noteContent">
						<p class="">
ページ名の後に、[ .html ]をつけている
/about<span>.html</span>
						</p>
					</div>
				</div>
			</div>
		</section>

	</main>
</template>

<script>

export default {
	name:'notFound',
  data: function () {
    return {
			pageTitle:"ページが見つかりませんでした",
			description:"ご指定のURLページがありません",
			keywords:"ページが見つかりません",
			ogType:"article",
		}
	},
  mounted: function() {
//インナーナビ情報通知
    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
//背景通知
    this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
    this.$store.commit('updateCurrentTitle', this.pageTitle)
    this.$store.commit('updateCurrentDescription', this.description)
    this.$store.commit('updateCurrentKeywords', this.keywords)
    this.$store.commit('updateCurrentOgUrl', this.isUrl)
    this.$store.commit('updateCurrentOgType', this.ogType)
    this.$store.commit('updateCurrentOgDesc', this.description)
    this.$store.commit('updateLinkCanonical', '')
  },
  updated: function() {
    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
    this.$store.commit('updatePageBackgroundStyle', '')
  },
}


</script>

<style>
</style>